import React from 'react'
import {
  MouseWheelAction,
  AnyActionType,
  IActionComponentProps,
} from '~core/forge.type'
import { MouseWheelInput } from '../components'
import useDispatch from '~editor/hooks/useDispatch'

interface IProps extends IActionComponentProps {
  action: MouseWheelAction
}

export const MouseWheelActionComponent = ({
  action,
  actions,
  activeActionGesture,
}: IProps) => {
  const dispatch = useDispatch()

  return (
    <MouseWheelInput
      value={action.direction}
      onChange={(direction) => {
        dispatch.nodes.updateActions({
          actionGestureType: activeActionGesture,
          actions: actions.map((_a: AnyActionType) => {
            const _action = { ..._a } as MouseWheelAction

            if (action.id === _action.id) {
              _action.direction = direction
            }

            return _action
          }),
        })
      }}
    />
  )
}

export default MouseWheelActionComponent
